import { render, staticRenderFns } from "./voteDelayAuditList.vue?vue&type=template&id=25ddb945&scoped=true"
import script from "./voteDelayAuditList.vue?vue&type=script&lang=js"
export * from "./voteDelayAuditList.vue?vue&type=script&lang=js"
import style0 from "./voteDelayAuditList.vue?vue&type=style&index=0&id=25ddb945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ddb945",
  null
  
)

export default component.exports